export const PICKUP_POINTS_RESET_STATE = 'PICKUP_POINTS_RESET_STATE';
export const PICKUP_POINTS_CURRENT_ITEM = 'PICKUP_POINTS_CURRENT_ITEM';

export const PICKUP_POINTS_REQUEST_LOADING = 'PICKUP_POINTS_REQUEST_LOADING';
export const PICKUP_POINTS_REQUEST_SUCCESS = 'PICKUP_POINTS_REQUEST_SUCCESS';
export const PICKUP_POINTS_REQUEST_FAILED = 'PICKUP_POINTS_REQUEST_FAILED';

export const PICKUP_POINTS_CURRENT_ACTION = 'PICKUP_POINTS_CURRENT_ACTION';
export const PICKUP_POINTS_RESET_ACTION = 'PICKUP_POINTS_RESET_ACTION';